export default "__VITE_ASSET__b11bcb39__"